"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichmentApiKeyClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class EnrichmentApiKeyClient extends authenticated_client_1.AuthenticatedClient {
    create(enrichmentIntegrationId, projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/enrichmentIntegrations/${enrichmentIntegrationId}/projects/${projectId}/api-keys/`, payload);
            return response.payload;
        });
    }
    update(id, enrichmentIntegrationId, projectId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/enrichmentIntegrations/${enrichmentIntegrationId}/projects/${projectId}/api-keys/${id}`, payload);
            return response.payload;
        });
    }
    findEnrichmentKey(enrichmentIntegrationId, projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/enrichmentIntegrations/${enrichmentIntegrationId}/projects/${projectId}/api-keys/`);
            return response.payload;
        });
    }
    findEnrichmentKeyById(id, enrichmentIntegrationId, projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/enrichmentIntegrations/${enrichmentIntegrationId}/projects/${projectId}/api-keys/${id}`);
            return response.payload;
        });
    }
    regenerate(id, enrichmentIntegrationId, projectId, regenerateRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/enrichmentIntegrations/${enrichmentIntegrationId}/projects/${projectId}/api-keys/${id}/regenerate`, regenerateRequest);
            return response.payload;
        });
    }
    revoke(id, enrichmentIntegrationId, projectId, revokePayload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/enrichmentIntegrations/${enrichmentIntegrationId}/projects/${projectId}/api-keys/${id}/revoke`, revokePayload);
            return response.payload;
        });
    }
}
exports.EnrichmentApiKeyClient = EnrichmentApiKeyClient;
//# sourceMappingURL=enrichment-api-keys.client.js.map